// import React, { useEffect, useState } from "react";
// import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";
// import { Card, FormControl, Table } from "react-bootstrap";
// import { authHeader } from "../../services/auth-header";
// import { BASE_URL } from "../../services/Api";
// import { IoIosArrowBack, IoIosArrowForward, IoMdSearch } from "react-icons/io";
// import Form from 'react-bootstrap/Form';

// const ProductionProcessTable = ({ header, tableTitle, apiField, type, addButton, createRoute, updateRoute, viewRoute }) => {

//     console.log({ header, tableTitle, apiField, type, addButton, createRoute, updateRoute, viewRoute });
//     const { id, pointindex } = useParams();
//     console.log(pointindex);
//     console.log(id);

//     const count = [{ "value": 5 }, { "value": 10 }, { "value": 20 }, { "value": 50 }, { "value": 100 }, { "value": 200 }];
//     const navigate = useNavigate();

//     //useStates
//     const [projectionData, setProjectionData] = useState([]);
//     const [search, setSearch] = useState(encodeURIComponent(' '));
//     const [pages, setPages] = useState();
//     const [currentPage, setCurrentPage] = useState(pointindex.length !== 0 ? pointindex - 1 : 0);
//     const [limit, setLimit] = useState(5);
//     const [sort, setSort] = useState("desc");
//     const [currentValue, setCurrentValue] = useState("id");
//     const [totalEnteries, setTotalEnteries] = useState();

//     async function getProjectionData() {

//         const response = await axios.get(`${BASE_URL}${apiField}/page/${currentPage}/${limit}/${sort}/${currentValue}/${type}/${search.length > 0 ? search : encodeURIComponent(' ')}`, {
//             headers: authHeader()
//         })
//             .then((response) => {
//                 console.log(`${BASE_URL}projection/page/${currentPage}/${limit}/${sort}/${currentValue}/${search}`);
//                 setProjectionData(response.data.Index !== undefined ? response.data.Index : response.data.data);
//                 setPages(response.data.Pages);
//                 setTotalEnteries(response.data.Enteries)
//             })
//             .catch((error) => {
//                 console.error(error);
//             })
//     }


//     //functions
//     function limitHandler(e) {
//         setLimit(e.target.value);
//         setCurrentPage(0);
//     }

//     function sortHandler(value) {
//         if (value.type === "svg") {
//             return;
//         }
//         setSort(sort === "asc" ? "desc" : "asc");
//         setCurrentValue(value);
//     }

//     function addButtonHandler() {
//         navigate(createRoute);
//     }

//     function handleRecentPage(i) {
//         setCurrentPage(i - 1)
//     };


//     function viewHandler(label, id) {
//         if (label === "Id") {
//             navigate(`${viewRoute}/${id}/${currentPage + 1}`)
//             return;
//         }
//         else {
//             // updateHandler(id);
//         }
//     };


//     console.log(id);


//     function pagination() {
//         const totalPages = pages;
//         const siblingsCount = 2;
//         const firstPage = 1;
//         const lastPage = totalPages;

//         let pageNumbers = [];

//         const startPage = Math.max(firstPage, currentPage + 1 - siblingsCount);
//         const endPage = Math.min(lastPage, currentPage + 1 + siblingsCount);

//         // Show first page button and dots if needed
//         if (startPage > firstPage + 1) {
//             pageNumbers.push(
//                 <button
//                     key={firstPage}
//                     className={`brand-page-btn ${firstPage === currentPage + 1 ? 'active' : ''}`}
//                     onClick={() => handleRecentPage(firstPage)}
//                 >
//                     {firstPage}
//                 </button>
//             );
//             pageNumbers.push(
//                 <span key="start-dots" className="brand-page-dots">...</span>
//             );
//         } else if (startPage > firstPage) {
//             pageNumbers.push(
//                 <button
//                     key={firstPage}
//                     className={`brand-page-btn ${firstPage === currentPage + 1 ? 'active' : ''}`}
//                     onClick={() => handleRecentPage(firstPage)}
//                 >
//                     {firstPage}
//                 </button>
//             );
//         }

//         // Main pagination buttons
//         for (let i = startPage; i <= endPage; i++) {
//             pageNumbers.push(
//                 <button
//                     key={i}
//                     className={`brand-page-btn ${i === currentPage + 1 ? 'active' : ''}`}
//                     onClick={() => handleRecentPage(i)}
//                 >
//                     {i}
//                 </button>
//             );
//         }

//         // Show last page button and dots if needed
//         if (endPage < lastPage - 1) {
//             pageNumbers.push(
//                 <span key="end-dots" className="brand-page-dots">...</span>
//             );
//             pageNumbers.push(
//                 <button
//                     key={lastPage}
//                     className={`brand-page-btn ${lastPage === currentPage + 1 ? 'active' : ''}`}
//                     onClick={() => handleRecentPage(lastPage)}
//                 >
//                     {lastPage}
//                 </button>
//             );
//         } else if (endPage < lastPage) {
//             pageNumbers.push(
//                 <button
//                     key={lastPage}
//                     className={`brand-page-btn ${lastPage === currentPage + 1 ? 'active' : ''}`}
//                     onClick={() => handleRecentPage(lastPage)}
//                 >
//                     {lastPage}
//                 </button>
//             );
//         }

//         return pageNumbers;
//     }



//     //useEffect
//     useEffect(() => {
//         getProjectionData();
//     }, []);

//     useEffect(() => {
//         getProjectionData();
//     }, [limit, sort, currentValue, search, currentPage]);

//     function previousHandler() {
//         setCurrentPage(currentPage - 1 < 0 ? 0 : currentPage - 1);
//     }

//     function nextHandler() {
//         setCurrentPage(currentPage + 1 > pages - 1 ? pages - 1 : currentPage + 1);
//     }




//     console.log(projectionData)
//     return (
//         <Card className="brand-card">

//             <Card.Header className="brand-header">
//                 <h6>{tableTitle}</h6>
//                 {addButton && (
//                     <button
//                         className="button-70"
//                         onClick={addButtonHandler}
//                     >
//                         {addButton}
//                     </button>
//                 )}
//             </Card.Header>

//             <Card.Body className="brand-body">
//                 <div className="brand-controls">
//                     <div className="brand-entries-control">
//                         <span className="brand-entries-label">Show entries:</span>
//                         <Form.Select
//                             className="brand-entries-select"
//                             onChange={limitHandler}
//                             value={limit}
//                         >
//                             {count.map((item) => (
//                                 <option key={item.value} value={item.value}>
//                                     {item.value}
//                                 </option>
//                             ))}
//                         </Form.Select>
//                     </div>

//                     <div className="brand-search-container">
//                         <FormControl
//                             className="brand-search"
//                             type="text"
//                             placeholder="Search..."
//                             value={search}
//                             onChange={(e) => setSearch(e.target.value)}
//                         />
//                     </div>
//                 </div>

//                 <Table striped bordered hover responsive className="brand-table">
//                     <thead>
//                         <tr>
//                             {header.map((head) => (
//                                 <th
//                                     key={head.field}
//                                     className={`brand-header-cell ${currentValue === head.field ? 'brand-sortable-active' : 'brand-sortable'}`}
//                                     onClick={() => sortHandler(head.field)}
//                                 >
//                                     {head.label}
//                                     {head.label !== "Action" && currentValue === head.field && (
//                                         <span className="brand-sort-icon">
//                                             {sort === "asc" ? <TiArrowSortedDown /> : <TiArrowSortedUp />}
//                                         </span>
//                                     )}
//                                 </th>
//                             ))}
//                         </tr>
//                     </thead>

//                     <tbody className="the">
//                         {projectionData && projectionData.length > 0 ? (
//                             projectionData.map((data) => (
//                                 <tr key={data.id}>
//                                     {header.map((head) => (
//                                         <td
//                                             key={head.field}
//                                             className={head.label === "Id" ? "id-column" : ""}
//                                             onClick={() => viewHandler(head.label, data.id)}
//                                         >
//                                             {data[head.field]}
//                                         </td>
//                                     ))}
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr className="brand-row">
//                                 <td colSpan={header.length} className="brand-empty">
//                                     No data found
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </Table>

//                 <div className="brand-pagination">
//                     <span className="brand-pagination-info">
//                         Showing {projectionData?.length || 0} of {totalEnteries} entries
//                     </span>

//                     <div className="brand-pagination-controls">
//                         <button
//                             className={`brand-pagination-btn ${currentPage === 0 ? 'disabled' : ''}`}
//                             onClick={previousHandler}
//                             disabled={currentPage === 0}
//                             title="Previous"
//                         >
//                             <IoIosArrowBack />
//                         </button>

//                         <div className="brand-pagination-pages">
//                             {pagination()}
//                         </div>

//                         <button
//                             className={`brand-pagination-btn ${currentPage >= pages - 1 ? 'disabled' : ''}`}
//                             onClick={nextHandler}
//                             disabled={currentPage >= pages - 1}
//                             title="Next"
//                         >
//                             <IoIosArrowForward />
//                         </button>
//                     </div>
//                 </div>
//             </Card.Body>
//         </Card>
//     );

// }

// export default ProductionProcessTable;




// import React, { useEffect, useState } from "react";
// import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";
// import { authHeader } from "../../services/auth-header";
// import { BASE_URL } from "../../services/Api";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
// import "../../Masters/Brand/BrandComponents.css";

// const ProductionProcessTable = ({
//     header,
//     tableTitle,
//     apiField,
//     type,
//     addButton,
//     createRoute,
//     updateRoute,
//     viewRoute
// }) => {
//     const { id, pointindex } = useParams();

//     const count = [
//         { value: 5 }, { value: 10 }, { value: 20 },
//         { value: 50 }, { value: 100 }, { value: 200 }
//     ];
//     const navigate = useNavigate();

//     const [projectionData, setProjectionData] = useState([]);
//     const [search, setSearch] = useState(encodeURIComponent(" "));
//     const [searchInput, setSearchInput] = useState("");
//     const [pages, setPages] = useState(1);
//     const [currentPage, setCurrentPage] = useState(pointindex && pointindex.length !== 0 ? pointindex - 1 : 0);
//     const [limit, setLimit] = useState(5);
//     const [sort, setSort] = useState("desc");
//     const [currentValue, setCurrentValue] = useState("id");
//     const [totalEnteries, setTotalEnteries] = useState(0);

//     async function getProjectionData() {
//         try {
//             const response = await axios.get(
//                 `${BASE_URL}${apiField}/page/${currentPage}/${limit}/${sort}/${currentValue}/${type}/${search.length > 0 ? search : encodeURIComponent(" ")}`,
//                 { headers: authHeader() }
//             );
//             setProjectionData(
//                 response.data.Index !== undefined ? response.data.Index : response.data.data
//             );
//             setPages(response.data.Pages);
//             setTotalEnteries(response.data.Enteries);
//         } catch (error) {
//             console.error(error);
//         }
//     }

//     useEffect(() => { getProjectionData(); }, []);
//     useEffect(() => { getProjectionData(); }, [limit, sort, currentValue, search, currentPage]);

//     // Debounced search
//     useEffect(() => {
//         const timer = setTimeout(() => {
//             setSearch(encodeURIComponent(searchInput.trim() || " "));
//             setCurrentPage(0);
//         }, 300);
//         return () => clearTimeout(timer);
//     }, [searchInput]);

//     const limitHandler = (e) => {
//         setLimit(e.target.value);
//         setCurrentPage(0);
//     };

//     const sortHandler = (value) => {
//         if (value.type === "svg") return;
//         setSort(sort === "asc" ? "desc" : "asc");
//         setCurrentValue(value);
//     };

//     const addButtonHandler = () => navigate(createRoute);

//     const handleRecentPage = (i) => setCurrentPage(i - 1);

//     const previousHandler = () => {
//         setCurrentPage(currentPage - 1 < 0 ? 0 : currentPage - 1);
//     };

//     const nextHandler = () => {
//         setCurrentPage(currentPage + 1 > pages - 1 ? pages - 1 : currentPage + 1);
//     };

//     const viewHandler = (label, id) => {
//         if (label === "Id" && viewRoute) {
//             navigate(`${viewRoute}/${id}/${currentPage + 1}`);
//         }
//     };

//     const renderPagination = () => {
//         const siblingsCount = 2;
//         const firstPage = 1;
//         const lastPage = pages;
//         let pageNumbers = [];

//         const startPage = Math.max(firstPage, currentPage + 1 - siblingsCount);
//         const endPage = Math.min(lastPage, currentPage + 1 + siblingsCount);

//         if (startPage > firstPage + 1) {
//             pageNumbers.push(
//                 <button key={firstPage} className="bc-page-btn" onClick={() => handleRecentPage(firstPage)}>
//                     {firstPage}
//                 </button>
//             );
//             pageNumbers.push(<span key="dots-start" className="bc-page-dots">...</span>);
//         } else if (startPage > firstPage) {
//             pageNumbers.push(
//                 <button key={firstPage} className="bc-page-btn" onClick={() => handleRecentPage(firstPage)}>
//                     {firstPage}
//                 </button>
//             );
//         }

//         for (let i = startPage; i <= endPage; i++) {
//             pageNumbers.push(
//                 <button
//                     key={i}
//                     className={`bc-page-btn${i === currentPage + 1 ? " bc-page-btn--active" : ""}`}
//                     onClick={() => handleRecentPage(i)}
//                 >
//                     {i}
//                 </button>
//             );
//         }

//         if (endPage < lastPage - 1) {
//             pageNumbers.push(<span key="dots-end" className="bc-page-dots">...</span>);
//             pageNumbers.push(
//                 <button key={lastPage} className="bc-page-btn" onClick={() => handleRecentPage(lastPage)}>
//                     {lastPage}
//                 </button>
//             );
//         } else if (endPage < lastPage) {
//             pageNumbers.push(
//                 <button key={lastPage} className="bc-page-btn" onClick={() => handleRecentPage(lastPage)}>
//                     {lastPage}
//                 </button>
//             );
//         }

//         return pageNumbers;
//     };

//     return (
//         <div className="bc-card">

//             {/* ── HEADER ── */}
//             <div className="bc-card__header">
//                 <h6 className="bc-card__title">{tableTitle}</h6>
//                 {addButton && (
//                     <button className="bc-add-btn" onClick={addButtonHandler}>
//                         {addButton}
//                     </button>
//                 )}
//             </div>

//             {/* ── BODY ── */}
//             <div className="bc-card__body">

//                 {/* Controls row */}
//                 <div className="bc-controls">
//                     <div className="bc-entries">
//                         <span className="bc-entries__label">Show entries:</span>
//                         <select className="bc-entries__select" onChange={limitHandler} value={limit}>
//                             {count.map((item) => (
//                                 <option key={item.value} value={item.value}>{item.value}</option>
//                             ))}
//                         </select>
//                     </div>

//                     <input
//                         className="bc-search"
//                         type="text"
//                         placeholder="Search..."
//                         value={searchInput}
//                         onChange={(e) => setSearchInput(e.target.value)}
//                     />
//                 </div>

//                 {/* Table */}
//                 <div className="bc-table-wrapper">
//                     <table className="bc-table">
//                         <thead>
//                             <tr>
//                                 {header.map((head) => (
//                                     head.label !== "Action" ? (
//                                         <th
//                                             key={head.field}
//                                             className={`bc-th bc-th--sortable${currentValue === head.field ? " bc-th--active" : ""}`}
//                                             onClick={() => sortHandler(head.field)}
//                                         >
//                                             {head.label}
//                                             {currentValue === head.field && (
//                                                 <span className="bc-sort-icon">
//                                                     {sort === "asc" ? <TiArrowSortedDown /> : <TiArrowSortedUp />}
//                                                 </span>
//                                             )}
//                                         </th>
//                                     ) : (
//                                         <th key={head.field} className="bc-th">{head.label}</th>
//                                     )
//                                 ))}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {projectionData && projectionData.length > 0 ? (
//                                 projectionData.map((data) => (
//                                     <tr key={data.id} className="bc-tr">
//                                         {header.map((head) => (
//                                             <td
//                                                 key={head.field}
//                                                 className="bc-td"
//                                                 onClick={() => viewHandler(head.label, data.id)}
//                                             >
//                                                 <span className={`bc-cell-text${head.label === "Id" ? " bc-cell-text--id" : ""}`}>
//                                                     {data[head.field]}
//                                                 </span>
//                                             </td>
//                                         ))}
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr className="bc-tr">
//                                     <td colSpan={header.length} className="bc-td bc-td--empty">
//                                         No data found
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>

//                 {/* Pagination */}
//                 <div className="bc-pagination">
//                     <span className="bc-pagination__info">
//                         Showing {projectionData?.length || 0} of {totalEnteries} entries
//                     </span>

//                     <div className="bc-pagination__controls">
//                         <button
//                             className={`bc-nav-btn${currentPage === 0 ? " bc-nav-btn--disabled" : ""}`}
//                             onClick={previousHandler}
//                             disabled={currentPage === 0}
//                             title="Previous"
//                         >
//                             <IoIosArrowBack />
//                         </button>

//                         <div className="bc-pages">
//                             {renderPagination()}
//                         </div>

//                         <button
//                             className={`bc-nav-btn${currentPage >= pages - 1 ? " bc-nav-btn--disabled" : ""}`}
//                             onClick={nextHandler}
//                             disabled={currentPage >= pages - 1}
//                             title="Next"
//                         >
//                             <IoIosArrowForward />
//                         </button>
//                     </div>
//                 </div>

//             </div>
//         </div>
//     );
// };

// export default ProductionProcessTable;




import React, { useEffect, useState } from "react";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { authHeader } from "../../services/auth-header";
import { BASE_URL } from "../../services/Api";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FiRefreshCw } from "react-icons/fi";
import "../../Masters/Brand/BrandComponents.css";

const ProductionProcessTable = ({
    header,
    tableTitle,
    apiField,
    type,
    addButton,
    createRoute,
    updateRoute,
    viewRoute
}) => {
    const { id, pointindex } = useParams();

    const count = [
        { value: 5 }, { value: 10 }, { value: 20 },
        { value: 50 }, { value: 100 }, { value: 200 }
    ];
    const navigate = useNavigate();

    const [projectionData, setProjectionData] = useState([]);
    const [search, setSearch] = useState(encodeURIComponent(" "));
    const [searchInput, setSearchInput] = useState("");
    const [pages, setPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(pointindex && pointindex.length !== 0 ? pointindex - 1 : 0);
    const [limit, setLimit] = useState(5);
    const [sort, setSort] = useState("desc");
    const [currentValue, setCurrentValue] = useState("id");
    const [totalEnteries, setTotalEnteries] = useState(0);
    const [isRefreshing, setIsRefreshing] = useState(false);

    async function getProjectionData() {
        try {
            const response = await axios.get(
                `${BASE_URL}${apiField}/page/${currentPage}/${limit}/${sort}/${currentValue}/${type}/${search.length > 0 ? search : encodeURIComponent(" ")}`,
                { headers: authHeader() }
            );
            setProjectionData(
                response.data.Index !== undefined ? response.data.Index : response.data.data
            );
            setPages(response.data.Pages);
            setTotalEnteries(response.data.Enteries);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => { getProjectionData(); }, []);
    useEffect(() => { getProjectionData(); }, [limit, sort, currentValue, search, currentPage]);

    // Debounced search
    useEffect(() => {
        const timer = setTimeout(() => {
            setSearch(encodeURIComponent(searchInput.trim() || " "));
            setCurrentPage(0);
        }, 300);
        return () => clearTimeout(timer);
    }, [searchInput]);

    const limitHandler = (e) => {
        setLimit(e.target.value);
        setCurrentPage(0);
    };

    const sortHandler = (value) => {
        if (value.type === "svg") return;
        setSort(sort === "asc" ? "desc" : "asc");
        setCurrentValue(value);
    };

    const addButtonHandler = () => navigate(createRoute);

    const refreshHandler = () => {
        setIsRefreshing(true);
        getProjectionData();
        setTimeout(() => setIsRefreshing(false), 600);
    };

    const handleRecentPage = (i) => setCurrentPage(i - 1);

    const previousHandler = () => {
        setCurrentPage(currentPage - 1 < 0 ? 0 : currentPage - 1);
    };

    const nextHandler = () => {
        setCurrentPage(currentPage + 1 > pages - 1 ? pages - 1 : currentPage + 1);
    };

    const viewHandler = (label, id) => {
        if (label === "Id" && viewRoute) {
            navigate(`${viewRoute}/${id}/${currentPage + 1}`);
        }
    };

    const renderPagination = () => {
        const siblingsCount = 2;
        const firstPage = 1;
        const lastPage = pages;
        let pageNumbers = [];

        const startPage = Math.max(firstPage, currentPage + 1 - siblingsCount);
        const endPage = Math.min(lastPage, currentPage + 1 + siblingsCount);

        if (startPage > firstPage + 1) {
            pageNumbers.push(
                <button key={firstPage} className="bc-page-btn" onClick={() => handleRecentPage(firstPage)}>
                    {firstPage}
                </button>
            );
            pageNumbers.push(<span key="dots-start" className="bc-page-dots">...</span>);
        } else if (startPage > firstPage) {
            pageNumbers.push(
                <button key={firstPage} className="bc-page-btn" onClick={() => handleRecentPage(firstPage)}>
                    {firstPage}
                </button>
            );
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <button
                    key={i}
                    className={`bc-page-btn${i === currentPage + 1 ? " bc-page-btn--active" : ""}`}
                    onClick={() => handleRecentPage(i)}
                >
                    {i}
                </button>
            );
        }

        if (endPage < lastPage - 1) {
            pageNumbers.push(<span key="dots-end" className="bc-page-dots">...</span>);
            pageNumbers.push(
                <button key={lastPage} className="bc-page-btn" onClick={() => handleRecentPage(lastPage)}>
                    {lastPage}
                </button>
            );
        } else if (endPage < lastPage) {
            pageNumbers.push(
                <button key={lastPage} className="bc-page-btn" onClick={() => handleRecentPage(lastPage)}>
                    {lastPage}
                </button>
            );
        }

        return pageNumbers;
    };

    return (
        <div className="bc-card">

            {/* ── TOOLBAR ── */}
            <div className="bc-toolbar">
                {/* Left: Search (flex-grow) */}
                <input
                    className="bc-search"
                    type="text"
                    placeholder="Search..."
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                />

                {/* Right: Show entries + Refresh + Add */}
                <div className="bc-toolbar__right">
                    <span className="bc-entries__label">Show:</span>
                    <select className="bc-entries__select" onChange={limitHandler} value={limit}>
                        {count.map((item) => (
                            <option key={item.value} value={item.value}>{item.value}</option>
                        ))}
                    </select>

                    <button
                        className={`bc-refresh-btn${isRefreshing ? ' bc-refresh-btn--spinning' : ''}`}
                        onClick={refreshHandler}
                        title="Refresh"
                    >
                        <FiRefreshCw size={14} />
                    </button>

                    {addButton && (
                        <button className="bc-add-btn" onClick={addButtonHandler}>
                            {addButton}
                        </button>
                    )}
                </div>
            </div>

            {/* ── TABLE ── */}
            <div className="bc-table-wrapper">
                <table className="bc-table">
                    <thead>
                        <tr>
                            {header.map((head) => (
                                head.label !== "Action" ? (
                                    <th
                                        key={head.field}
                                        className={`bc-th bc-th--sortable${currentValue === head.field ? " bc-th--active" : ""}`}
                                        onClick={() => sortHandler(head.field)}
                                    >
                                        {head.label}
                                        {currentValue === head.field && (
                                            <span className="bc-sort-icon">
                                                {sort === "asc" ? <TiArrowSortedDown /> : <TiArrowSortedUp />}
                                            </span>
                                        )}
                                    </th>
                                ) : (
                                    <th key={head.field} className="bc-th">{head.label}</th>
                                )
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {projectionData && projectionData.length > 0 ? (
                            projectionData.map((data) => (
                                <tr key={data.id} className="bc-tr">
                                    {header.map((head) => (
                                        <td
                                            key={head.field}
                                            className="bc-td"
                                            onClick={() => viewHandler(head.label, data.id)}
                                        >
                                            <span className={`bc-cell-text${head.label === "Id" ? " bc-cell-text--id" : ""}`}>
                                                {data[head.field]}
                                            </span>
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr className="bc-tr">
                                <td colSpan={header.length} className="bc-td bc-td--empty">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* ── PAGINATION ── */}
            <div className="bc-pagination">
                <span className="bc-pagination__info">
                    Showing {projectionData?.length || 0} of {totalEnteries} entries
                </span>

                <div className="bc-pagination__controls">
                    <button
                        className={`bc-nav-btn${currentPage === 0 ? " bc-nav-btn--disabled" : ""}`}
                        onClick={previousHandler}
                        disabled={currentPage === 0}
                        title="Previous"
                    >
                        <IoIosArrowBack />
                    </button>

                    <div className="bc-pages">
                        {renderPagination()}
                    </div>

                    <button
                        className={`bc-nav-btn${currentPage >= pages - 1 ? " bc-nav-btn--disabled" : ""}`}
                        onClick={nextHandler}
                        disabled={currentPage >= pages - 1}
                        title="Next"
                    >
                        <IoIosArrowForward />
                    </button>
                </div>
            </div>

        </div>
    );
};

export default ProductionProcessTable;